"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOciPlatformType = void 0;
const isOciPlatformType = (cluster) => {
    var _a, _b, _c;
    return (((_a = cluster.platform) === null || _a === void 0 ? void 0 : _a.type) === 'external' && ((_c = (_b = cluster.platform) === null || _b === void 0 ? void 0 : _b.external) === null || _c === void 0 ? void 0 : _c.platformName) === 'oci');
};
exports.isOciPlatformType = isOciPlatformType;
//# sourceMappingURL=utils.js.map